import { http } from '@/http/http.js'
//获取组织结构
export function getOrganizationList(params) {
    return http.post("/web/dept/list", params)
}
//获取分组信息
export function getGroupList(params) {
    return http.post("/web/employee/list", params)
}
//获取相关枚举
export function getDictList(params) {
    return http.post("/common/getDictList", params)
}
//删除人员
export function deleteStaff(params) {
    return http.post("/web/employee/delete", params)
}
//修改员工状态
export function updateStaffJobStatus(params) {
    return http.post("/web/employee/updateJobStatus", params)
}
//根据人员id修改人员
export function updateStaffInfo(params) {
    return http.post("/web/employee/update", params)
}
//根据人员id查询人员消息
export function queryStaffInfo(params) {
    return http.post("/web/employee/info", params)
}
//新增人员
export function addStaff(params) {
    return http.post("/web/employee/save", params)
}
//上传文件
export function exportEmployeeDataByFile(pathName, param) {
    return http.postFile("/web/employee/exportEmployeeDataByFile", "", param);
}